module.exports = __webpack_public_path__ + "images/185_4096.jpg";